import { IModularEnrolmentSlice, ModularEnrolmentSteps } from './types';

export const initialState: IModularEnrolmentSlice = {
    policyId: '',
    currentStep: ModularEnrolmentSteps.BASE_PLAN,
    selectedBasePlan: '',
    selectedAlaCarte: [],
    selectedAddOns: [], // for add-on benefits
    personalEmail: '',
    upgradedFamilyStructure: undefined,
    userBenefits: {},
    baseFamilyStructure: {
        data: undefined,
        loading: false,
        error: null
    },
    purchaseAttributes: {},
    family: {
        data: [],
        loading: false,
        error: null
    },
    basePlans: {
        data: null,
        loading: false,
        error: null
    },
    alaCarteBenefits: {
        data: null,
        loading: false,
        error: null
    },
    addOnBenefits: {
        data: null,
        loading: false,
        error: null
    },
    summary: {
        data: null,
        loading: false,
        error: null
    }
};
